import React from 'react'

const MyContext = React.createContext({ name: "默认名称", age: 1 })

export default MyContext